import Button from "@mui/material/Button";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";
import { TextField } from "src/components/Default/LekUI/TextField";
import newApi from "src/newApi";
import * as Yup from "yup";

import { TextWithLink } from "../../../Default/LekUI/Layout/TextWithLink";

function ResetPassword() {
	const history = useHistory();
	const { t } = useTranslation();

	const {
		handleSubmit,
		handleChange: handleChangeFormik,
		values,
		errors,
		setErrors,
		setFieldError,
		isSubmitting,
	} = useFormik({
		initialValues: {
			email: "",
		},
		validateOnChange: false,
		onSubmit: async (values) => {
			try {
				await newApi.resetPassword(values.email);
				return history.push({
					pathname: generatePath(routing.paths.successResetPassword),
				});
			} catch {
				setFieldError("email", t("errors.somethingWentWrong"));
			}
		},
		validationSchema: Yup.object().shape({
			email: Yup.string()
				.email()
				.required()
				.typeError(t("errors.requiredField")),
		}),
	});

	const handleChange = (...params) => {
		setErrors({});
		handleChangeFormik(...params);
	};

	const steps = () => (
		<>
			<TextField
				variant="outlined"
				margin="normal"
				required
				id="email"
				label={t("auth.resetPassword.form.email")}
				name="email"
				type="email"
				onChange={handleChange}
				autoComplete="email"
				value={values.email}
				error={errors.email}
			/>
			<Button variant="contained" type="submit">
				{isSubmitting
					? t("auth.resetPassword.form.sending")
					: t("commands.send")}
			</Button>
		</>
	);

	return (
		<>
			<p>{t("auth.resetPassword.form.subtitle")}</p>
			<form onSubmit={handleSubmit} className="reset-password">
				{steps()}
			</form>
			<TextWithLink
				link={routing.paths.signIn}
				linkText={t("auth.signIn")}
				questionText={t("auth.signInQuestion")}
			/>
		</>
	);
}

export default ResetPassword;
